import { Box, Button, ButtonGroup, H3, P, Stack } from "@adfenix/alexandria";
import { Modal } from "components/Modal";
import { integrations } from "./integrations";
import Divider from "components/Divider";
import { useMutation } from "@tanstack/react-query";
import Sentry from "lib/sentry/init";
import { toast } from "react-toastify";
import { sendIntegrationRequest } from "api/services/customerPortalService";
import useUserInfo from "hooks/useUserInfo";
import { userSelectedHq } from "atoms/auth";
import { useRecoilValue } from "recoil";

interface Props {
  integrationFormState: Record<string, boolean>;
  setShow: (show: boolean) => void;
  resetForm: () => void;
}

export const SubmitModal = ({
  integrationFormState,
  setShow,
  resetForm
}: Props) => {
  const { mutate, isLoading } = useMutation(sendIntegrationRequest, {
    onSuccess: () => {
      toast.success("Integration request submitted.");
      resetForm();
      setShow(false);
    },
    onError: e => {
      Sentry.captureException(e);
      toast.error("Something went wrong. Please refresh and try again.");
    }
  });
  const supportedIntegrations = integrations.filter(
    x => integrationFormState[x.propertyKey]
  );

  const hq = useRecoilValue(userSelectedHq);

  const { userEmail } = useUserInfo();
  return (
    <Modal show={true} onClose={() => {}}>
      <Modal.Card style={{ padding: "16px" }}>
        <Stack spacing="m">
          <H3>Submit integration request</H3>

          <Box>
            <P>The following integrations will be requested:</P>
            <ul>
              {supportedIntegrations.map(integration => (
                <li
                  style={{ listStyleType: "disc", marginLeft: "16px" }}
                  key={integration.propertyKey}
                >
                  {integration.name}
                </li>
              ))}
            </ul>
          </Box>

          <Divider />

          <ButtonGroup justifyContent="end">
            <Button
              logLabel="modal-create-integration-close-button"
              variant="secondary"
              onClick={() => setShow(false)}
            >
              Cancel
            </Button>
            <Button
              logLabel="modal-create-integration-submit-button"
              isLoading={isLoading}
              onClick={async () => {
                await mutate({
                  integrationFormState: {
                    campaignData: integrationFormState.campaignData,
                    requester: userEmail,
                    apiIntegration: integrationFormState.apiIntegration,
                    cdp: integrationFormState.cdp,
                    crmLeadRouting: integrationFormState.crmLeadRouting,
                    frontEnd: integrationFormState.frontEnd,
                    hqId: hq?.id ?? "",
                    hqName: hq?.name ?? "",
                    sso: integrationFormState.sso
                  }
                });
              }}
            >
              Submit
            </Button>
          </ButtonGroup>
        </Stack>
      </Modal.Card>
    </Modal>
  );
};
